var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRedCoupon16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 7c-.553 0-1 .447-1 1 0 .553.447 1 1 1v2.333c0 .734-.6 1.334-1.333 1.334H2.333c-.733 0-1.333-.6-1.333-1.334V9c.553 0 1-.447 1-1 0-.553-.447-1-1-1V4.667c0-.734.6-1.334 1.333-1.334h11.334c.733 0 1.333.6 1.333 1.334V7Z",
  fill: "#F74F2A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.106 6.22a.887.887 0 1 1-1.773 0 .887.887 0 0 1 1.773 0ZM9.78 10.66a.887.887 0 1 0 0-1.773.887.887 0 0 0 0 1.773ZM5.526 10.467c.06.066.147.1.234.1h.006c.08 0 .167-.034.234-.1l4.473-4.474a.33.33 0 0 0 0-.473.33.33 0 0 0-.473 0L5.526 9.993a.33.33 0 0 0 0 .474Z",
  fill: "#fff"
})));
export default SvgRedCoupon16X16;